export default "__VITE_ASSET__ce958fec__"